import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import i18n from './i18n/index'
import locale from 'element-ui/lib/locale/lang/en'
// import VCharts from 'v-charts'
import animated from 'animate.css'
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
import AMap from 'vue-amap';
Vue.use(AMap);
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '8f0167753d34a6ad3a9d5744d6180122',
  lang:"zh_en",
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation']
});
Vue.use(ElementUI, { locale })
Vue.use(animated)
Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
